/**
 * ErrorCodeEnum
 */
export enum ErrorCode {
  WCH006 = "WCH006",
  DEFAULT = "DEFAULT",
}
